module.exports = __webpack_public_path__ + "img/Ptuapp12.eaba51fd.png";